import { features } from "./homeData";

export function FeaturesSection() {
  return (
    <section className="bg-navy-band py-20 md:py-28 border-y border-navy-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <p className="overline mb-3">Features</p>
          <h2 className="h-display text-3xl md:text-4xl">Built for modern conveyancing firms.</h2>
          <p className="mt-4 text-navy-600 text-lg">Every feature solves a specific operational pain — not a generic legal-tech checklist.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {features.map((f) => (
            <div key={f.title} className="card-soft p-6 flex items-start gap-4" data-testid={`feature-${f.title.substring(0, 20)}`}>
              <span className="w-10 h-10 rounded-lg bg-navy-50 text-navy-700 flex items-center justify-center shrink-0">
                <f.icon className="w-5 h-5" strokeWidth={1.8} />
              </span>
              <div>
                <p className="font-display text-[17px] text-navy-900">{f.title}</p>
                <p className="mt-1.5 text-sm text-navy-600 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
